<template>
  <v-container>
    <v-row class="text-center">
        <HoverCard
        v-for="card in cards"
        v-bind:key="card.title"
        v-bind:title="card.title"
        v-bind:image="card.image"
        v-bind:route="card.route"
        v-bind:color="card.color"
        v-bind:desc="card.desc"
      ></HoverCard>
    </v-row>
  </v-container>
</template>

<script>
  import HoverCard from '../components/HoverCard';

  export default {
    name: 'HelloWorld',
    components: {
      HoverCard,
    },
    data: () => ({

    }),
    computed: {
      cards () {
        return this.$store.state.searchedCards;
      }
    }
  }
</script>